export default function RecipeDivider({ icon = "leaf" }) {
  return (
    <div
      className="flex items-center justify-center gap-4 my-2"
      data-testid="recipe-divider"
    >
      <span className="block h-px w-20 sm:w-32 stitched-divider" />
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        className="text-[hsl(var(--sage-deep))]"
        aria-hidden
      >
        {icon === "leaf" ? (
          <path
            d="M3 12c4-9 14-9 18-9-1 4-2 14-11 18-5-3-7-8-7-9z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinejoin="round"
          />
        ) : (
          <path
            d="M12 21s-7-5-7-11a4 4 0 017-2 4 4 0 017 2c0 6-7 11-7 11z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinejoin="round"
          />
        )}
      </svg>
      <span className="block h-px w-20 sm:w-32 stitched-divider" />
    </div>
  );
}
